export default {
    courseData: {},
    courseSections: {},
    processing: false,
};